// Helpers MA CARTE PROXI
const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Les médias uploadés sont servis par le backend (/api/cartes/media/...)
export const mediaUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("/api")) return `${BACKEND}${u}`;
  return u;
};

export const publicUrl = (slug) => `${window.location.origin}/carte/${slug}`;
export const qrUrl = (slug) => `${BACKEND}/api/cartes/public/${slug}/qr?fmt=png`;
export const vcardUrl = (slug) => `${BACKEND}/api/cartes/public/${slug}/vcard`;
export const pdfUrl = (slug) => `${BACKEND}/api/cartes/public/${slug}/pdf`;

export const phoneDigits = (p) => (p || "").replace(/[^0-9+]/g, "");

// Numéro WhatsApp au format international (0X… -> 33X…, retire le +)
export const waNumber = (p) => {
  let d = (p || "").replace(/[^0-9+]/g, "");
  if (d.startsWith("+")) d = d.slice(1);
  else if (d.startsWith("0")) d = "33" + d.slice(1);
  return d;
};

// Construit la liste des boutons d'action d'une carte
export function buildButtons(card) {
  const a = card.actions || {};
  const c = card.contact || {};
  const out = [];
  const add = (key, label, icon, href, external = false) => out.push({ key, label, icon, href, external });
  if (a.call && c.phone) add("call", "Appeler", "Phone", `tel:${phoneDigits(c.phone)}`);
  if (a.sms && c.phone) add("sms", "SMS", "MessageSquare", `sms:${phoneDigits(c.phone)}`);
  if (a.whatsapp && (c.whatsapp || c.phone)) add("whatsapp", "WhatsApp", "MessageCircle", `https://wa.me/${waNumber(c.whatsapp || c.phone)}`, true);
  if (a.email && c.email) add("email", "E-mail", "Mail", `mailto:${c.email}`);
  if (a.website && c.website) add("website", "Site web", "Globe", normalizeUrl(c.website), true);
  if (a.directions && c.address) add("directions", "Itinéraire", "MapPin", `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(c.address)}`, true);
  if (a.devis) add("devis", "Demander un devis", "FileText", `${window.location.origin}/demande-de-devis`, false);
  (card.links || []).forEach((l, i) => {
    if (l && l.url) add(`link_${i}`, l.label || "Lien", "Link2", normalizeUrl(l.url), true);
  });
  return out;
}

export function normalizeUrl(u) {
  if (!u) return "#";
  if (/^https?:\/\//i.test(u)) return u;
  if (/^(mailto:|tel:|sms:)/i.test(u)) return u;
  return `https://${u}`;
}

export const SOCIAL_LABELS = {
  facebook: "Facebook", instagram: "Instagram", linkedin: "LinkedIn",
  twitter: "Twitter/X", x: "Twitter/X", youtube: "YouTube", tiktok: "TikTok",
  whatsapp: "WhatsApp", website: "Site web", other: "Lien",
};
